import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faLocationDot, faBook } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { experience, socialLinks } from "../../lib/Data/personalData.ts";
import { useLanguage } from "../../lib/LanguageContext/LanguageContext.tsx";
import Earth from "../Earth/Earth.tsx";
import styles from "./Hero.module.scss";

const Hero: React.FC = () => {
  const { currentLang, t } = useLanguage();
  const currentLocation =
    currentLang === "zh" ? experience[0].locationZh : experience[0].location;

  // Format greeting to wrap emoji in span and prevent name wrapping
  const formattedGreeting = t("greeting")
    .replace(/(Sharon here 👋)/, '<span style="white-space: nowrap">$1</span>')
    .replace(/(Sharon 👋)/, '<span style="white-space: nowrap">$1</span>')
    .replace(/(👋)/, '<span class="wave-emoji" role="img" aria-label="waving hand">👋</span>');

  return (
    <section className={styles.headerContainer}>
      <div className={styles.textContainer}>
        <h1
          className={styles.greeting}
          dangerouslySetInnerHTML={{ __html: formattedGreeting }}
        ></h1>
        <h2 className={styles.subtitle}>
          <span>{t("intro")}</span>
        </h2>
        <div className={styles.socialLinks}>
          <a
            href="https://docs.sharonwang.me/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.docsButton}
            aria-label={t("visitDocs")}
          >
            <FontAwesomeIcon icon={faBook} />
            <span>Docs</span>
          </a>
          <a
            href={socialLinks.linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            aria-label="Visit LinkedIn profile"
          >
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
          <a
            href={socialLinks.github}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.socialLink}
            aria-label="Visit GitHub profile"
          >
            <FontAwesomeIcon icon={faGithub} />
          </a>
          <div className={styles.currentLocation}>
            <FontAwesomeIcon
              icon={faLocationDot}
              style={{ color: "#dc2626" }}
              aria-hidden="true"
            />
            <span>{currentLocation}</span>
          </div>
        </div>
      </div>
      <div className={styles.earthWrapper}>
        <Earth />
      </div>
    </section>
  );
};

export default Hero;
